import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DentalXChangeRTBRequestModel} from '../../../models/accountsReceivable/dentalxchange-rtb-request.model';
import {InsuranceService} from '../insurance.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DXCEligibilityResponse, DXCEligibilityResponsePlan} from '../../../models/insurance/dxc/patient-eligibility';
import {parseJson} from '@angular/cli/src/utilities/json-file';
import {DXCAddress} from '../../../models/insurance/dxc/common';
import {DoctorQueryOptionsModel} from '../../../models/doctors/doctor-query-options.model';
import {DoctorsService} from '../../../services/doctors.service';
import {DoctorDataModel} from '../../../models/doctors/doctor-data.model';
import {ARService} from '../../ar/ar.service';

@Component({
  selector: 'app-insurance-rtb-dialog',
  templateUrl: './insurance-rtb-dialog.component.html',
  styleUrls: ['./insurance-rtb-dialog.component.css']
})
export class InsuranceRtbDialogComponent implements OnInit {

  isLoading: boolean = true;
  patientInsuranceId: string;
  providerDoctorId: string;
  queryModel: DoctorQueryOptionsModel;

  // this is any because it's coming from dentalxchange - will develop models after discovery process
  rtbResponse: any;
  patientEligibilityResponse: DXCEligibilityResponse;
  jsonResp: DXCEligibilityResponse;
  doctorList: DoctorDataModel[];
  currentDoctor: DoctorDataModel;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private insuranceService: InsuranceService,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<InsuranceRtbDialogComponent>,
    public doctorService: DoctorsService,
    ) { }

  ngOnInit(): void {

    if (this.data != null) {
      this.patientInsuranceId = this.data.PatientInsuranceID;
      this.loadDrList();
      //this.providerDoctorId = this.data.ProviderDoctorID;
      // this.loadRTBService2();
    }

    // this.loadTestData();
    this.isLoading = false;
  }

  async loadDrList() {
    console.log('get dr list');
    this.showMessage('Running...', 'Loading doctor list');
    this.queryModel = new DoctorQueryOptionsModel();
    this.queryModel.isActiveOnly = false;
    this.queryModel.isIncludeTdo = true;
    this.queryModel.isIncludeReferring = false;
    this.queryModel.isLazyLoad = true;

    await this.doctorService.getDoctors(this.queryModel).subscribe(dataDoc => {
      this.doctorList = dataDoc;
    });
  }

  loadRTBService2() {
    if (this.currentDoctor && this.currentDoctor.DoctorId) {
      this.showMessage('Running...', 'Contacting RTB API');
      this.insuranceService.getRTBResponse(this.patientInsuranceId, this.currentDoctor.DoctorId)
        .subscribe(response => {
          this.rtbResponse = response;
          this.patientEligibilityResponse = response;
          this.jsonResp = response;

          this.isLoading = false;
        }, err => {
          this.showMessage('Error', 'Error getting RTB response');
        });
    }
    else {
      // dr not selected
      this.showMessage('Please select a Doctor to continue', 'Error');
    }
  }

  returnAddress(address: DXCAddress) {
    let addr = '';
    if (address.address1) {
      addr += address.address1 + '\n';
    }
    if (address.address2) {
      addr += address.address2 + '\n';
    }
    if (address.city) {
      addr += address.city + ' ';
    }
    if (address.state) {
      addr += address.state + ' ';
    }
    if (address.zipCode) {
      addr += address.zipCode;
    }

    return addr;
  }

  returnPlan(plan: DXCEligibilityResponsePlan) {
    return '';
  }

  // loadRTBService() {
  //
  //   const request = new DentalXChangeRTBRequestModel();
  //   // request.DrNPI = '1811033103';
  //   // request.DrFirstName = 'Gary';
  //   // request.DrLastName = 'Carr';
  //   // request.DrSSN = '123664567';
  //   // request.DrAddress = '12 Merit Circle';
  //   // request.DrCity = 'Laguna Hills';
  //   // request.DrState = 'Ca';
  //   // request.DrZip = '92656';
  //   //
  //   // request.DrUserName = 'TDOXTest';
  //   // request.DrPassword = 'Demotest1';
  //   //
  //   // request.PatientFirstName = 'Jack';
  //   // request.PatientLastName = 'Sheeran';
  //   // request.PatientDOB = '19510101';
  //   // request.PatientGender = 'M  ';
  //   // request.PatientInsuranceCompany = '07000';
  //   //
  //   // request.SubscriberFirstName = 'Jack';
  //   // request.SubscriberLastName = 'Sheeran';
  //   // request.SubscriberDOB = '19510101';
  //   // request.SubscriberGender = 'M';
  //   // request.SubscriberSSN = '168991245';
  //
  //   request.DrNPI = '1811033103';
  //   request.DrFirstName = 'Gary';
  //   request.DrLastName = 'Carr';
  //   request.DrSSN = '123664567';
  //   request.DrAddress = '12 Merit Circle';
  //   request.DrCity = 'Laguna Hills';
  //   request.DrState = 'Ca';
  //   request.DrZip = '92656';
  //
  //   request.DrUserName = 'TDOXTest';
  //   request.DrPassword = 'Demotest1';
  //
  //   request.PatientFirstName = 'Jack';
  //   request.PatientLastName = 'Sheeran';
  //   request.PatientDOB = '19510101';
  //   request.PatientGender = 'M  ';
  //   request.PatientInsuranceCompany = '07000';
  //
  //   request.SubscriberFirstName = 'Jack';
  //   request.SubscriberLastName = 'Sheeran';
  //   request.SubscriberDOB = '19510101';
  //   request.SubscriberGender = 'M';
  //   request.SubscriberSSN = '168991245';
  //
  //   this.insuranceService.postRTBRequest(request)
  //     .subscribe(response => {
  //       this.rtbResponse = response;
  //       this.isLoading = false;
  //
  //       // check response content
  //       const blah = this.rtbResponse.contentField.indexOf('Your request was rejected');
  //       if (this.rtbResponse.contentField.indexOf('Your request was rejected') < 0) {
  //         // content appears to be valid
  //         // this.launchRTBResponseViewer();
  //         this.rtbResponseHTML = this.rtbResponse.contentField;
  //       }
  //       else {
  //         // error
  //         this.showMessage('Error', this.rtbResponse.contentField);
  //       }
  //     }, err => {
  //       this.showMessage('Error', 'Error getting rtb response');
  //     });
  // }

  showMessage(type, message) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  loadTables() {

  }

  loadTestData() {
    const test = '{\n' +
      '  "status": {\n' +
      '    "code": 0,\n' +
      '    "description": "Operation Successful"\n' +
      '  },\n' +
      '  "messages": [],\n' +
      '  "transactionId": 46566439,\n' +
      '  "response": {\n' +
      '    "payer": {\n' +
      '      "id": "61271",\n' +
      '      "name": "PRINCIPAL LIFE INSURANCE COMPANY"\n' +
      '    },\n' +
      '    "subscriber": {\n' +
      '      "firstName": "Kolton",\n' +
      '      "lastName": "Gonzalez",\n' +
      '      "address": {\n' +
      '        "address1": "9386 STREET",\n' +
      '        "address2": "",\n' +
      '        "city": "YUMA",\n' +
      '        "state": "AZ",\n' +
      '        "zipCode": "85364"\n' +
      '      },\n' +
      '      "dateOfBirth": "10/07/1969",\n' +
      '      "gender": "U",\n' +
      '      "plan": {\n' +
      '        "groupNumber": "9037935",\n' +
      '        "groupName": "",\n' +
      '        "subscriberId": "915792612",\n' +
      '        "coverageIndicator": "",\n' +
      '        "effectiveDateFrom": "03/01/2012"\n' +
      '      }\n' +
      '    },\n' +
      '    "patient": {\n' +
      '      "firstName": "Kolton",\n' +
      '      "lastName": "Gonzalez",\n' +
      '      "address": {\n' +
      '        "address1": "9386 STREET",\n' +
      '        "address2": "",\n' +
      '        "city": "YUMA",\n' +
      '        "state": "AZ",\n' +
      '        "zipCode": "85364"\n' +
      '      },\n' +
      '      "dateOfBirth": "10/07/1969",\n' +
      '      "relationship": "Self",\n' +
      '      "gender": "U",\n' +
      '      "plan": {\n' +
      '        "groupNumber": "9037935",\n' +
      '        "groupName": "",\n' +
      '        "subscriberId": "915792612",\n' +
      '        "coverageIndicator": "",\n' +
      '        "effectiveDateFrom": "03/01/2012"\n' +
      '      }\n' +
      '    },\n' +
      '    "activeCoverage": [\n' +
      '      {\n' +
      '        "serviceType": "Dental Care",\n' +
      '        "planCoverageDescription": "THE PRINCIPAL PLAN DENTAL",\n' +
      '        "insuranceType": "Group Policy",\n' +
      '        "message": "The patient should see an In Network dentist for the best benefit.\\nLesser benefits are available by visiting a non-participating dentist.\\nA different fee schedule may apply according to leased agreements.\\nBenefits for non-participating Dentists are based on a set fee\\nschedule. Call 800-247-4695 to check participation. A missing tooth\\nclause applies to services such as the initial placement of full or\\npartial dentures, fixed bridges, implants, and implant crowns. These\\nservices are only covered if the natural teeth being replaced were\\nextracted while covered under this plan. Predeterminations are not\\nrequired prior to services being rendered. A predetermination may be\\nrecommended for certain services Coordination of Benefits are\\ndetermined by the Standard/Birthday Rule as defined by NAIC These\\nbenefits listed are for calendar year for maximums and calendar year\\nfor deductibles. Dependent dental will be terminated when dependent\\nhas turned 26 years old.\\n"\n' +
      '      }\n' +
      '    ],\n' +
      '    "coInsurance": [\n' +
      '      {\n' +
      '        "serviceType": "Routine (Preventive) Dental",\n' +
      '        "network": "In-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "5",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      '      },\n' +
      '      {\n' +
      '        "serviceType": "Routine (Preventive) Dental",\n' +
      '        "network": "Out-Of-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "20",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      '      },\n' +
      '      {\n' +
      '        "serviceType": "Restorative",\n' +
      '        "network": "In-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "10",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      '      },\n' +
      '      {\n' +
      '        "serviceType": "Restorative",\n' +
      '        "network": "Out-Of-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "40",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      '      },\n' +
      '      {\n' +
      '        "serviceType": "Diagnostic Dental",\n' +
      '        "network": "In-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "40",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      '      },\n' +
      '      {\n' +
      '        "serviceType": "Diagnostic Dental",\n' +
      '        "network": "Out-Of-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "60",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      '      },\n' +
      '      {\n' +
      '        "serviceType": "Dental Care",\n' +
      '        "network": "In-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "50",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "TMJ Rider with a individual deductible of 0.00 (0.00 remaining),\\nfamily deductible of 0.00 (0.00 remaining), and maximum of 500.00\\n(500.00 remaining)\\n"\n' +
      '      },\n' +
      '      {\n' +
      '        "serviceType": "Dental Care",\n' +
      '        "network": "Out-Of-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "50",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "TMJ Rider with a individual deductible of 0.00 (0.00 remaining),\\nfamily deductible of 0.00 (0.00 remaining), and maximum of 500.00\\n(500.00 remaining)\\n"\n' +
      '      },\n' +
      '      {\n' +
      '        "code": "D0120",\n' +
      '        "network": "In-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "5",\n' +
      '        "authorizationRequired": "No",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "Covered under Preventive Frequency - 1 per 6 consecutive months to the\\nexact day Eligible as of 04/23/2023 Last service history - 09/23/2020\\nD9430 is covered only if no other service is provided during the\\nvisit. Maximum benefit payable for a D0150 submitted for an\\nestablished patient may be based on a D0120.\\n"\n' +
      '      },\n' +
      '      {\n' +
      '        "code": "D0120",\n' +
      '        "network": "Out-Of-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "20",\n' +
      '        "authorizationRequired": "No",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "Covered under Preventive Frequency - 1 per 6 consecutive months to the\\nexact day Eligible as of 04/23/2023 Last service history - 09/23/2020\\nD9430 is covered only if no other service is provided during the\\nvisit. Maximum benefit payable for a D0150 submitted for an\\nestablished patient may be based on a D0120.\\n"\n' +
      '      },\n' +
      '      {\n' +
      '        "code": "D0140",\n' +
      '        "network": "In-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "10",\n' +
      '        "authorizationRequired": "No",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "Covered under Basic Frequency - 1 per 6 consecutive months to the\\nexact day Eligible as of 04/23/2023 Last service history - 09/23/2020\\nLimited oral evaluation is considered with or without other procedures\\non same date of service.\\n"\n' +
      '      },\n' +
      '      {\n' +
      '        "code": "D0140",\n' +
      '        "network": "Out-Of-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "40",\n' +
      '        "authorizationRequired": "No",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "Covered under Basic Frequency - 1 per 6 consecutive months to the\\nexact day Eligible as of 04/23/2023 Last service history - 09/23/2020\\nLimited oral evaluation is considered with or without other procedures\\non same date of service.\\n"\n' +
      '      },\n' +
      '      {\n' +
      '        "code": "D0210",\n' +
      '        "network": "In-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "5",\n' +
      '        "authorizationRequired": "No",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "Covered under Preventive Frequency - 1 per 60 consecutive months to\\nthe exact day Eligible as of 04/23/2023 No service history The maximum\\nbenefit payable for eligible x-rays on a given date of service is that\\nof a full mouth series. If the patient is not eligible for bitewings,\\nbenefits for a full mouth series will be reduced by the amount\\npreviously paid for the bitewings. D0701 and D0709 are only payable\\nwhen submitted by an x-ray facility.\\n"\n' +
      '      },\n' +
      '      {\n' +
      '        "code": "D0210",\n' +
      '        "network": "Out-Of-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "20",\n' +
      '        "authorizationRequired": "No",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "Covered under Preventive Frequency - 1 per 60 consecutive months to\\nthe exact day Eligible as of 04/23/2023 No service history The maximum\\nbenefit payable for eligible x-rays on a given date of service is that\\nof a full mouth series. If the patient is not eligible for bitewings,\\nbenefits for a full mouth series will be reduced by the amount\\npreviously paid for the bitewings. D0701 and D0709 are only payable\\nwhen submitted by an x-ray facility.\\n"\n' +
      '      },\n' +
      '      {\n' +
      '        "code": "D0220",\n' +
      '        "network": "In-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "5",\n' +
      '        "authorizationRequired": "No",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "Covered under Preventive Frequency - 4 per calendar year Eligible as\\nof 04/23/2023 Last service history - 01/03/2021 The maximum benefit\\npayable for eligible x-rays on a given date of service is that of a\\nfull mouth series. D0707 is only payable when submitted by an x-ray\\nfacility.\\n"\n' +
      '      },\n' +
      '      {\n' +
      '        "code": "D0220",\n' +
      '        "network": "Out-Of-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "20",\n' +
      '        "authorizationRequired": "No",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "Covered under Preventive Frequency - 4 per calendar year Eligible as\\nof 04/23/2023 Last service history - 01/03/2021 The maximum benefit\\npayable for eligible x-rays on a given date of service is that of a\\nfull mouth series. D0707 is only payable when submitted by an x-ray\\nfacility.\\n"\n' +
      '      },\n' +
      '      {\n' +
      '        "code": "D0270",\n' +
      '        "network": "In-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "5",\n' +
      '        "authorizationRequired": "No",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "Covered under Preventive Frequency - 1 per 6 consecutive months to the\\nexact day Eligible as of 04/23/2023 Last service history - 02/10/2018\\nFor ages 12 and older, bitewings are limited to up to 4 bitewings per\\noccurrence. The maximum benefit payable for eligible x-rays on a given\\ndate of service is that of a full mouth series. D0708 is only payable\\nwhen submitted by an x-ray facility.\\n"\n' +
      '      },\n' +
      '      {\n' +
      '        "code": "D0270",\n' +
      '        "network": "Out-Of-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "20",\n' +
      '        "authorizationRequired": "No",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "Covered under Preventive Frequency - 1 per 6 consecutive months to the\\nexact day Eligible as of 04/23/2023 Last service history - 02/10/2018\\nFor ages 12 and older, bitewings are limited to up to 4 bitewings per\\noccurrence. The maximum benefit payable for eligible x-rays on a given\\ndate of service is that of a full mouth series. D0708 is only payable\\nwhen submitted by an x-ray facility.\\n"\n' +
      '      },\n' +
      '      {\n' +
      '        "code": "D1110",\n' +
      '        "network": "In-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "5",\n' +
      '        "authorizationRequired": "No",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "Covered under Preventive Frequency - 1 per 6 consecutive months to the\\nexact day Eligible as of 04/23/2023 Last service history - 01/11/2020\\nNot covered if less than 90 days have passed since active periodontal\\ntherapy was completed. If under age 14, benefit limited to child\\nprophylaxis (D1120)\\n"\n' +
      '      },\n' +
      '      {\n' +
      '        "code": "D1110",\n' +
      '        "network": "Out-Of-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "20",\n' +
      '        "authorizationRequired": "No",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "Covered under Preventive Frequency - 1 per 6 consecutive months to the\\nexact day Eligible as of 04/23/2023 Last service history - 01/11/2020\\nNot covered if less than 90 days have passed since active periodontal\\ntherapy was completed. If under age 14, benefit limited to child\\nprophylaxis (D1120)\\n"\n' +
      '      },\n' +
      '      {\n' +
      '        "code": "D1551",\n' +
      '        "network": "In-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "10",\n' +
      '        "authorizationRequired": "No",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "Covered under Basic Frequency - 1 per 24 consecutive months to the\\nexact day Considered if at least 12 months since insertion of the\\nspace maintainer. Considered only for dependent children under age 14\\n"\n' +
      '      },\n' +
      '      {\n' +
      '        "code": "D1551",\n' +
      '        "network": "Out-Of-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "40",\n' +
      '        "authorizationRequired": "No",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "Covered under Basic Frequency - 1 per 24 consecutive months to the\\nexact day Considered if at least 12 months since insertion of the\\nspace maintainer. Considered only for dependent children under age 14\\n"\n' +
      '      },\n' +
      '      {\n' +
      '        "code": "D4910",\n' +
      '        "network": "In-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "10",\n' +
      '        "authorizationRequired": "No",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "Covered under Basic Frequency - 1 per 6 consecutive months to the\\nexact day Not Eligible Last service history - 01/11/2020 Procedure is\\nonly covered if documentation in history of prior treatment for\\nperiodontal disease which was deemed dentally necessary. The following\\nallowed procedures qualify a patient for a D4910 D4210, D4211, D4240,\\nD4241, D4260, D4261, D4341, D4342, and D4910 If treatment for\\nperiodontal disease was provided prior to coverage with us, this\\nprocedure is only covered by us if a statement of the qualifying\\nprocedure performed is provided along with the initial submission of\\nthe D4910. This procedure is only covered by us if at least 90 days\\nhave passed since the qualifying periodontal therapy listed above was\\ncompleted.\\n"\n' +
      '      },\n' +
      '      {\n' +
      '        "code": "D4910",\n' +
      '        "network": "Out-Of-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "40",\n' +
      '        "authorizationRequired": "No",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "Covered under Basic Frequency - 1 per 6 consecutive months to the\\nexact day Not Eligible Last service history - 01/11/2020 Procedure is\\nonly covered if documentation in history of prior treatment for\\nperiodontal disease which was deemed dentally necessary. The following\\nallowed procedures qualify a patient for a D4910 D4210, D4211, D4240,\\nD4241, D4260, D4261, D4341, D4342, and D4910 If treatment for\\nperiodontal disease was provided prior to coverage with us, this\\nprocedure is only covered by us if a statement of the qualifying\\nprocedure performed is provided along with the initial submission of\\nthe D4910. This procedure is only covered by us if at least 90 days\\nhave passed since the qualifying periodontal therapy listed above was\\ncompleted.\\n"\n' +
      '      },\n' +
      '      {\n' +
      '        "code": "D1208",\n' +
      '        "network": "In-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "5",\n' +
      '        "authorizationRequired": "No",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "Covered under Preventive Frequency - 1 per 6 consecutive months to the\\nexact day Not Eligible No service history Considered only for\\ndependent children under age 14\\n"\n' +
      '      },\n' +
      '      {\n' +
      '        "code": "D1208",\n' +
      '        "network": "Out-Of-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "20",\n' +
      '        "authorizationRequired": "No",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "Covered under Preventive Frequency - 1 per 6 consecutive months to the\\nexact day Not Eligible No service history Considered only for\\ndependent children under age 14\\n"\n' +
      '      },\n' +
      '      {\n' +
      '        "code": "D1351",\n' +
      '        "network": "In-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "10",\n' +
      '        "authorizationRequired": "No",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "Covered under Basic Frequency - 1 per 36 consecutive months to the\\nexact day Considered only for dependent children under age 14\\nApplicable only to the occlusal surface of first and second permanent\\nmolars.\\n"\n' +
      '      },\n' +
      '      {\n' +
      '        "code": "D1351",\n' +
      '        "network": "Out-Of-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "40",\n' +
      '        "authorizationRequired": "No",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "Covered under Basic Frequency - 1 per 36 consecutive months to the\\nexact day Considered only for dependent children under age 14\\nApplicable only to the occlusal surface of first and second permanent\\nmolars.\\n"\n' +
      '      },\n' +
      '      {\n' +
      '        "code": "D1510",\n' +
      '        "network": "In-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "10",\n' +
      '        "authorizationRequired": "No",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "Covered under Basic Frequency - Covered once per site per lifetime\\nConsidered only for dependent children under age 14\\n"\n' +
      '      },\n' +
      '      {\n' +
      '        "code": "D1510",\n' +
      '        "network": "Out-Of-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "percent": "40",\n' +
      '        "authorizationRequired": "No",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      '        "message": "Covered under Basic Frequency - Covered once per site per lifetime\\nConsidered only for dependent children under age 14\\n"\n' +
      '      }\n' +
      // '      {\n' +
      // '        "code": "D2140",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "10",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Basic Frequency - 1 replacement every 24 months to the\\nexact day Composites are considered at an amalgam rate for posterior\\nteeth which includes molars and pre-molars (bicuspids).\\nMesial-lingual, distal-lingual, mesial-buccal, and distal buccal\\nrestorations for anterior teeth will be considered at the rate of a\\nsingle surface restoration. Multiple restorations on adjacent surfaces\\nof the same tooth are considered connected and will be based on the\\nrate for a single restoration reflecting the number of different\\nsurfaces. Multiple restorations on the same surface of the same tooth\\nare considered at the rate for a single surface restoration.\\nRestorations replacing tooth structure lost from abrasion, attrition,\\nabfraction and erosion are not covered. These services are subject to\\nIndividual and/or Consultant review. See Submission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D2140",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Basic Frequency - 1 replacement every 24 months to the\\nexact day Composites are considered at an amalgam rate for posterior\\nteeth which includes molars and pre-molars (bicuspids).\\nMesial-lingual, distal-lingual, mesial-buccal, and distal buccal\\nrestorations for anterior teeth will be considered at the rate of a\\nsingle surface restoration. Multiple restorations on adjacent surfaces\\nof the same tooth are considered connected and will be based on the\\nrate for a single restoration reflecting the number of different\\nsurfaces. Multiple restorations on the same surface of the same tooth\\nare considered at the rate for a single surface restoration.\\nRestorations replacing tooth structure lost from abrasion, attrition,\\nabfraction and erosion are not covered. These services are subject to\\nIndividual and/or Consultant review. See Submission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D2750",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 120 month replacement These services\\nare subject to Individual and/or Consultant review. See Submission\\nGuidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nCovered services are paid on seat date Molars/Pre-molars are based\\nupon the alternate benefit of a noble metal cast crown. Anterior teeth\\nare based upon the alternate benefit of a porcelain fused to noble\\nmetal cast crown. These codes are covered services only if placed to\\nrestore a tooth broken down due to tooth decay or injury resulting in\\nthe loss of tooth structure. (Injury does not include damage to teeth\\nthat results from chewing or biting food, substances or objects). 3/4\\nCrowns are not covered on anterior teeth. 3/4 Crown coverage is\\nlimited to Molar/Pre-molars.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D2750",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 120 month replacement These services\\nare subject to Individual and/or Consultant review. See Submission\\nGuidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nCovered services are paid on seat date Molars/Pre-molars are based\\nupon the alternate benefit of a noble metal cast crown. Anterior teeth\\nare based upon the alternate benefit of a porcelain fused to noble\\nmetal cast crown. These codes are covered services only if placed to\\nrestore a tooth broken down due to tooth decay or injury resulting in\\nthe loss of tooth structure. (Injury does not include damage to teeth\\nthat results from chewing or biting food, substances or objects). 3/4\\nCrowns are not covered on anterior teeth. 3/4 Crown coverage is\\nlimited to Molar/Pre-molars.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D2980",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 per 24 consecutive months to the\\nexact day Covered only if done more than 12 months after initial\\ninsertion of crown/onlay\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D2980",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 per 24 consecutive months to the\\nexact day Covered only if done more than 12 months after initial\\ninsertion of crown/onlay\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D2930",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "10",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Basic Frequency - 120 month replacement Crowns replacing\\ntooth structure lost from abrasion, attrition, abfraction and erosion\\nare not covered. If used as a temporary, not covered If a permanent\\ncrown replaces a stainless steel/resin/prefabricated crown at a later\\ndate but before replacement restrictions allow, all new charges will\\nbe reduced by those already paid.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D2930",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Basic Frequency - 120 month replacement Crowns replacing\\ntooth structure lost from abrasion, attrition, abfraction and erosion\\nare not covered. If used as a temporary, not covered If a permanent\\ncrown replaces a stainless steel/resin/prefabricated crown at a later\\ndate but before replacement restrictions allow, all new charges will\\nbe reduced by those already paid.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D2920",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 per 24 consecutive months to the\\nexact day Covered only if done more than 12 months after initial\\ninsertion of crown/onlay\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D2920",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 per 24 consecutive months to the\\nexact day Covered only if done more than 12 months after initial\\ninsertion of crown/onlay\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D2940",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "10",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Basic Frequency - None Eligible as of 04/23/2023 No\\nservice history D2940 is covered only if not performed on the same\\ndate as the permanent restoration. Not to be used to report endodontic\\naccess closure.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D2940",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Basic Frequency - None Eligible as of 04/23/2023 No\\nservice history D2940 is covered only if not performed on the same\\ndate as the permanent restoration. Not to be used to report endodontic\\naccess closure.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D2950",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 120 month replacement These services\\nare subject to Individual and/or Consultant review. See Submission\\nGuidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nConsidered only when required for retention and preservation of tooth.\\nNo benefits payable if restorative procedures are not covered.\\nBuildups submitted with the same date of service as a full cast crown\\nare considered. Please bill for the crown on the seat date and for the\\nbuildup on the date it is performed.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D2950",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 120 month replacement These services\\nare subject to Individual and/or Consultant review. See Submission\\nGuidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nConsidered only when required for retention and preservation of tooth.\\nNo benefits payable if restorative procedures are not covered.\\nBuildups submitted with the same date of service as a full cast crown\\nare considered. Please bill for the crown on the seat date and for the\\nbuildup on the date it is performed.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D3220",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - Covered once per site per lifetime Not\\nto be construed as the first stage of root canal therapy.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D3220",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - Covered once per site per lifetime Not\\nto be construed as the first stage of root canal therapy.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D3332",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history\\nPlease provide diagnostic x-rays and a narrative or office notes for\\nreview.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D3332",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history\\nPlease provide diagnostic x-rays and a narrative or office notes for\\nreview.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D3331",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history\\nPlease provide diagnostic x-rays and a narrative or office notes for\\nreview.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D3331",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history\\nPlease provide diagnostic x-rays and a narrative or office notes for\\nreview.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D3310",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - Covered once per site per lifetime\\nIncludes intra-operative x-rays.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D3310",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - Covered once per site per lifetime\\nIncludes intra-operative x-rays.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D3330",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - Covered once per site per lifetime\\nIncludes intra-operative x-rays.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D3330",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - Covered once per site per lifetime\\nIncludes intra-operative x-rays.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D3346",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - Covered once per site per lifetime\\nIncludes intra-operative x-rays.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D3346",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - Covered once per site per lifetime\\nIncludes intra-operative x-rays.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D3348",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - Covered once per site per lifetime\\nIncludes intra-operative x-rays.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D3348",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - Covered once per site per lifetime\\nIncludes intra-operative x-rays.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D3333",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history\\nPlease provide diagnostic x-rays and a narrative or office notes for\\nreview.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D3333",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history\\nPlease provide diagnostic x-rays and a narrative or office notes for\\nreview.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D3410",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - Covered once per site per lifetime"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D3410",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - Covered once per site per lifetime"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D3430",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - Covered once per site per lifetime"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D3430",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - Covered once per site per lifetime"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D4263",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - Covered once per site per lifetime\\nThese services are subject to Individual and/or Consultant review. See\\nSubmission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nBone Grafting of an extraction site is not covered.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D4263",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - Covered once per site per lifetime\\nThese services are subject to Individual and/or Consultant review. See\\nSubmission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nBone Grafting of an extraction site is not covered.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D4260",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 per 36 consecutive months to the\\nexact day These services are subject to Individual and/or Consultant\\nreview. See Submission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nGingival grafts are considered a covered service only when necessary\\nto treat a soft tissue defect. They are not considered a covered\\nservice if done for reasons of sensitivity or for cosmetic purposes.\\nNo restrictions on number of quadrants completed same date of service\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D4260",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 per 36 consecutive months to the\\nexact day These services are subject to Individual and/or Consultant\\nreview. See Submission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nGingival grafts are considered a covered service only when necessary\\nto treat a soft tissue defect. They are not considered a covered\\nservice if done for reasons of sensitivity or for cosmetic purposes.\\nNo restrictions on number of quadrants completed same date of service\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D4212",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 per 36 consecutive months to the\\nexact day These services are subject to Individual and/or Consultant\\nreview. See Submission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nPlease provide diagnostic x-rays and a narrative or office notes for\\nreview.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D4212",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 per 36 consecutive months to the\\nexact day These services are subject to Individual and/or Consultant\\nreview. See Submission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nPlease provide diagnostic x-rays and a narrative or office notes for\\nreview.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D4249",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 per 36 consecutive months to the\\nexact day These services are subject to Individual and/or Consultant\\nreview. See Submission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nPlease provide x-rays for review. No benefit for crown lengthening is\\npayable if performed on same date of service as the crown.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D4249",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 per 36 consecutive months to the\\nexact day These services are subject to Individual and/or Consultant\\nreview. See Submission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nPlease provide x-rays for review. No benefit for crown lengthening is\\npayable if performed on same date of service as the crown.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D4341",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 per 24 consecutive months to the\\nexact day These services are subject to Individual and/or Consultant\\nreview. See Submission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nThese services are considered only when there is visible pathologic\\nradiographic bone loss resulting in subsequent loss of attachment. No\\nrestrictions on number of quadrants completed same date of service\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D4341",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 per 24 consecutive months to the\\nexact day These services are subject to Individual and/or Consultant\\nreview. See Submission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nThese services are considered only when there is visible pathologic\\nradiographic bone loss resulting in subsequent loss of attachment. No\\nrestrictions on number of quadrants completed same date of service\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D4346",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "10",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Basic Frequency - 1 per 24 consecutive months to the\\nexact day Eligible as of 04/23/2023 No service history Considered if\\nat least 6 months have elapsed since last prophylaxis. This service is\\nonly appropriate when a patient has swollen, inflamed gingiva,\\ngeneralized suprabony pockets and moderate to severe bleeding on\\nprobing in the absence of attachment loss No benefits are payable if\\nthe patient has history of periodontal treatment. Limited to persons\\nage 14 and over.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D4346",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Basic Frequency - 1 per 24 consecutive months to the\\nexact day Eligible as of 04/23/2023 No service history Considered if\\nat least 6 months have elapsed since last prophylaxis. This service is\\nonly appropriate when a patient has swollen, inflamed gingiva,\\ngeneralized suprabony pockets and moderate to severe bleeding on\\nprobing in the absence of attachment loss No benefits are payable if\\nthe patient has history of periodontal treatment. Limited to persons\\nage 14 and over.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D4355",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "10",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Basic Frequency - 1 per lifetime Eligible as of\\n04/23/2023 No service history Covered as a separate procedure only if\\nno other service (except x-rays and/or a non-comprehensive exam) is\\nprovided during the visit. This procedure is not a covered service by\\nus if the patient has had a prophylaxis, periodontal maintenance, or\\nscaling and root planing within the past 24 months.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D4355",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Basic Frequency - 1 per lifetime Eligible as of\\n04/23/2023 No service history Covered as a separate procedure only if\\nno other service (except x-rays and/or a non-comprehensive exam) is\\nprovided during the visit. This procedure is not a covered service by\\nus if the patient has had a prophylaxis, periodontal maintenance, or\\nscaling and root planing within the past 24 months.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D5110",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 replacement every 60 months to the\\nexact day Covered services are paid on seat date A missing tooth\\nclause does apply. Please submit extraction date(s). If replacing a\\nprior prosthetic, submit date of prior prosthetic and clinical\\nnarrative.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D5110",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 replacement every 60 months to the\\nexact day Covered services are paid on seat date A missing tooth\\nclause does apply. Please submit extraction date(s). If replacing a\\nprior prosthetic, submit date of prior prosthetic and clinical\\nnarrative.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D5211",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 replacement every 60 months to the\\nexact day Covered services are paid on seat date A missing tooth\\nclause does apply. Please submit extraction date(s). If replacing a\\nprior prosthetic, submit date of prior prosthetic and clinical\\nnarrative.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D5211",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 replacement every 60 months to the\\nexact day Covered services are paid on seat date A missing tooth\\nclause does apply. Please submit extraction date(s). If replacing a\\nprior prosthetic, submit date of prior prosthetic and clinical\\nnarrative.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D5511",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 per 24 consecutive months to the\\nexact day Must be at least 12 months since denture/partial denture\\ninsertion.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D5511",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 per 24 consecutive months to the\\nexact day Must be at least 12 months since denture/partial denture\\ninsertion.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D5611",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 per 24 consecutive months to the\\nexact day Must be at least 12 months since denture/partial denture\\ninsertion.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D5611",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 per 24 consecutive months to the\\nexact day Must be at least 12 months since denture/partial denture\\ninsertion.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D5710",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 per 24 consecutive months to the\\nexact day Must be at least 12 months since denture/partial denture\\ninsertion.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D5710",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 per 24 consecutive months to the\\nexact day Must be at least 12 months since denture/partial denture\\ninsertion.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D5740",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 per 24 consecutive months to the\\nexact day Must be at least 12 months since denture/partial denture\\ninsertion.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D5740",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 1 per 24 consecutive months to the\\nexact day Must be at least 12 months since denture/partial denture\\ninsertion.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D6010",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "0",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Implant Rider Frequency - 120 month replacement A\\nmissing tooth clause does apply. Please submit extraction date(s). If\\nimplant is replacing a prior prosthetic, submit date of prior\\nprosthetic and clinical narrative. If an existing prosthesis is\\npresent where the implant is being placed, then replacement frequency\\nof the existing prosthesis must be met. We recommend submission of a\\npredetermination.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D6010",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "0",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Implant Rider Frequency - 120 month replacement A\\nmissing tooth clause does apply. Please submit extraction date(s). If\\nimplant is replacing a prior prosthetic, submit date of prior\\nprosthetic and clinical narrative. If an existing prosthesis is\\npresent where the implant is being placed, then replacement frequency\\nof the existing prosthesis must be met. We recommend submission of a\\npredetermination.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D6056",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "0",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Implant Rider Frequency - 120 month replacement Covered\\nservices are paid on seat date A missing tooth clause does apply.\\nPlease submit extraction date(s). Custom abutments are considered at\\nthe prefabricated abutment rate If implant is replacing a prior\\nprosthetic, submit date of prior prosthetic and clinical narrative. If\\nan existing prosthesis is present where the implant is being placed,\\nthen replacement frequency of the existing prosthesis must be met. We\\nrecommend submission of a predetermination. Please submit extraction\\ndate. If implant is replacing a prior prosthetic, submit date of prior\\nprosthetic and clinical narrative.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D6056",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "0",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Implant Rider Frequency - 120 month replacement Covered\\nservices are paid on seat date A missing tooth clause does apply.\\nPlease submit extraction date(s). Custom abutments are considered at\\nthe prefabricated abutment rate If implant is replacing a prior\\nprosthetic, submit date of prior prosthetic and clinical narrative. If\\nan existing prosthesis is present where the implant is being placed,\\nthen replacement frequency of the existing prosthesis must be met. We\\nrecommend submission of a predetermination. Please submit extraction\\ndate. If implant is replacing a prior prosthetic, submit date of prior\\nprosthetic and clinical narrative.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D6058",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 120 month replacement A missing tooth\\nclause does apply. Please submit extraction date(s). Molars/Pre-molars\\nare based upon the alternate benefit of a noble metal cast implant\\ncrown. Anterior teeth are based upon the alternate benefit of a\\nporcelain fused to noble metal cast implant crown. If an existing\\nprosthesis is present where the implant is being placed, then\\nreplacement frequency of the existing prosthesis must be met. Covered\\nservices are paid on seat date We recommend submission of a\\npredetermination including FMX or Pano and list of all missing teeth\\nin the arch. If replacement, include date of prior prosthetic and\\nclinical narrative. Please submit extraction date. If implant is\\nreplacing a prior prosthetic, submit date of prior prosthetic and\\nclinical narrative.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D6058",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 120 month replacement A missing tooth\\nclause does apply. Please submit extraction date(s). Molars/Pre-molars\\nare based upon the alternate benefit of a noble metal cast implant\\ncrown. Anterior teeth are based upon the alternate benefit of a\\nporcelain fused to noble metal cast implant crown. If an existing\\nprosthesis is present where the implant is being placed, then\\nreplacement frequency of the existing prosthesis must be met. Covered\\nservices are paid on seat date We recommend submission of a\\npredetermination including FMX or Pano and list of all missing teeth\\nin the arch. If replacement, include date of prior prosthetic and\\nclinical narrative. Please submit extraction date. If implant is\\nreplacing a prior prosthetic, submit date of prior prosthetic and\\nclinical narrative.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D6104",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "0",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Implant Rider Frequency - 120 month replacement This\\nbone graft code is only considered if performed on the same day as\\nimplant placement. These services are subject to Individual and/or\\nConsultant review based on service, complexity, and length of\\nprocedure. See Submission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nPlease submit x-rays, perio charting, and clinical diagnosis.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D6104",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "0",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Implant Rider Frequency - 120 month replacement This\\nbone graft code is only considered if performed on the same day as\\nimplant placement. These services are subject to Individual and/or\\nConsultant review based on service, complexity, and length of\\nprocedure. See Submission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nPlease submit x-rays, perio charting, and clinical diagnosis.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D6100",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "0",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Implant Rider Eligible as of 04/23/2023 No service\\nhistory Limited to persons age 16 and over.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D6100",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "0",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Implant Rider Eligible as of 04/23/2023 No service\\nhistory Limited to persons age 16 and over.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D6055",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "0",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Implant Rider Eligible as of 04/23/2023 No service\\nhistory Limited to persons age 16 and over.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D6055",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "0",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Implant Rider Eligible as of 04/23/2023 No service\\nhistory Limited to persons age 16 and over.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D6080",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "0",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Implant Rider Frequency - 2 per calendar year Limited to\\npersons age 16 and over.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D6080",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "0",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Implant Rider Frequency - 2 per calendar year Limited to\\npersons age 16 and over.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D6095",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "0",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Implant Rider Frequency - 1 per 24 consecutive months to\\nthe exact day Limited to persons age 16 and over. Considered if at\\nleast 12 months have elapsed since insertion of the implant abutment.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D6095",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "0",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Implant Rider Frequency - 1 per 24 consecutive months to\\nthe exact day Limited to persons age 16 and over. Considered if at\\nleast 12 months have elapsed since insertion of the implant abutment.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D6101",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "0",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Implant Rider Frequency - 1 per 36 consecutive months to\\nthe exact day Limited to persons age 16 and over. Please provide\\ncurrent x-rays, periodontal charting, mobility measure of implant, and\\nclinical diagnosis.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D6101",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "0",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Implant Rider Frequency - 1 per 36 consecutive months to\\nthe exact day Limited to persons age 16 and over. Please provide\\ncurrent x-rays, periodontal charting, mobility measure of implant, and\\nclinical diagnosis.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D6205",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 120 month replacement We recommend\\nsubmission of a predetermination including diagnostic x-rays\\nMolars/Pre-molars are based upon the alternate benefit of a noble\\nmetal cast crown. Anterior teeth are based upon the alternate benefit\\nof a porcelain fused to noble metal cast crown. Covered services are\\npaid on seat date A missing tooth clause does apply. Please submit\\nextraction date(s). These services are subject to Individual and/or\\nConsultant review. See Submission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nIf replacing a prior prosthetic, submit date of prior prosthetic and\\nclinical narrative.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D6205",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 120 month replacement We recommend\\nsubmission of a predetermination including diagnostic x-rays\\nMolars/Pre-molars are based upon the alternate benefit of a noble\\nmetal cast crown. Anterior teeth are based upon the alternate benefit\\nof a porcelain fused to noble metal cast crown. Covered services are\\npaid on seat date A missing tooth clause does apply. Please submit\\nextraction date(s). These services are subject to Individual and/or\\nConsultant review. See Submission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nIf replacing a prior prosthetic, submit date of prior prosthetic and\\nclinical narrative.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7140",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history These\\nservices are subject to Individual and/or Consultant review. See\\nSubmission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nA predetermination is recommended. We do not require claims for oral\\nsurgery to be sent to the employee\\"s medical insurance first.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7140",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history These\\nservices are subject to Individual and/or Consultant review. See\\nSubmission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nA predetermination is recommended. We do not require claims for oral\\nsurgery to be sent to the employee\\"s medical insurance first.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7240",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history These\\nservices are subject to Individual and/or Consultant review. See\\nSubmission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nA predetermination is recommended. We do not require claims for oral\\nsurgery to be sent to the employee\\"s medical insurance first.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7240",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history These\\nservices are subject to Individual and/or Consultant review. See\\nSubmission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nA predetermination is recommended. We do not require claims for oral\\nsurgery to be sent to the employee\\"s medical insurance first.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7261",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - None Eligible as of 04/23/2023 No\\nservice history Please provide diagnostic x-rays, a clinical\\nnarrative, and office notes for review.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7261",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - None Eligible as of 04/23/2023 No\\nservice history Please provide diagnostic x-rays, a clinical\\nnarrative, and office notes for review.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D8080",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "0",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Ortho Not Eligible No service history The lifetime\\nmaximum will be reduced by the amount paid by the prior plan/carrier.\\nPlease provide the name of the previous insurance carrier and the\\namount paid towards orthodontia. The benefit for the initial fee is\\n25% of the lifetime maximum or the total fee, whichever is less. We\\nautomate ongoing payments monthly, based on the patient\\"s eligibility\\nand benefit maximum. There is no need to submit periodic orthodontic\\ntreatment visits. There are no benefits payable if the appliance or\\nbands were placed prior to the effective date, unless treatment was in\\nprogress under prior group orthodontic coverage, and no lapse in\\ncoverage. X-rays, diagnostic casts, and photos for orthodontic\\npurposes are covered under orthodontia benefits. Cone beam x-rays are\\nnot covered. Clear aligners are covered under orthodontia. Appliances\\ncovered Bionator, Crozat, Edgewise, Expansion, Frankle, Hawly, Hebst,\\nNord, Palatal Expansion, Quad Helix, Retainers, Ricketts, Sagittal\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D8080",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "0",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Ortho Not Eligible No service history The lifetime\\nmaximum will be reduced by the amount paid by the prior plan/carrier.\\nPlease provide the name of the previous insurance carrier and the\\namount paid towards orthodontia. The benefit for the initial fee is\\n25% of the lifetime maximum or the total fee, whichever is less. We\\nautomate ongoing payments monthly, based on the patient\\"s eligibility\\nand benefit maximum. There is no need to submit periodic orthodontic\\ntreatment visits. There are no benefits payable if the appliance or\\nbands were placed prior to the effective date, unless treatment was in\\nprogress under prior group orthodontic coverage, and no lapse in\\ncoverage. X-rays, diagnostic casts, and photos for orthodontic\\npurposes are covered under orthodontia benefits. Cone beam x-rays are\\nnot covered. Clear aligners are covered under orthodontia. Appliances\\ncovered Bionator, Crozat, Edgewise, Expansion, Frankle, Hawly, Hebst,\\nNord, Palatal Expansion, Quad Helix, Retainers, Ricketts, Sagittal\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D8210",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "100",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D8210",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "100",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D8670",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "0",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Ortho Not Eligible No service history There is no need\\nto submit periodic orthodontic treatment visits. We automate ongoing\\npayments monthly.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D8670",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "0",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Ortho Not Eligible No service history There is no need\\nto submit periodic orthodontic treatment visits. We automate ongoing\\npayments monthly.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D9110",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "10",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Basic Eligible as of 04/23/2023 Last service history -\\n03/01/2018 Covered only if no other service (except x-rays) is\\nprovided during the visit There is no age limitation for palliative\\ntreatments.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D9110",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Basic Eligible as of 04/23/2023 Last service history -\\n03/01/2018 Covered only if no other service (except x-rays) is\\nprovided during the visit There is no age limitation for palliative\\ntreatments.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D9222",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history These\\nservices are subject to Individual and/or Consultant review based on\\nservice, complexity, and length of procedure. See Submission\\nGuidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nGeneral Anesthesia or IV Sedation is payable for removal of impacted\\nteeth or coronectomy, surgical removal of 4 third molars on the same\\nday, removal of dental cysts/tumors, multiple restorative services for\\nChildren under age 5, osseous surgery, bone grafting. General\\nAnesthesia or IV Sedation isn\\"t covered when used for more than one\\nhour, the service isn\\"t covered, used for patient management. A\\npredetermination is recommended.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D9222",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history These\\nservices are subject to Individual and/or Consultant review based on\\nservice, complexity, and length of procedure. See Submission\\nGuidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nGeneral Anesthesia or IV Sedation is payable for removal of impacted\\nteeth or coronectomy, surgical removal of 4 third molars on the same\\nday, removal of dental cysts/tumors, multiple restorative services for\\nChildren under age 5, osseous surgery, bone grafting. General\\nAnesthesia or IV Sedation isn\\"t covered when used for more than one\\nhour, the service isn\\"t covered, used for patient management. A\\npredetermination is recommended.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D9612",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "10",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Basic Eligible as of 04/23/2023 No service history\\nCovered for antibiotic drug administration only. Please submit the\\nname of the drug for review. Covered only if performed in conjunction\\nwith General Anesthesia or IV Sedation.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D9612",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Basic Eligible as of 04/23/2023 No service history\\nCovered for antibiotic drug administration only. Please submit the\\nname of the drug for review. Covered only if performed in conjunction\\nwith General Anesthesia or IV Sedation.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D9310",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "10",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Basic Frequency - 1 per 12 consecutive months to the\\nexact day Eligible as of 04/23/2023 No service history Limited to a\\nspecialist Covered only if no other service (except x-rays) is\\nprovided during the visit\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D9310",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Basic Frequency - 1 per 12 consecutive months to the\\nexact day Eligible as of 04/23/2023 No service history Limited to a\\nspecialist Covered only if no other service (except x-rays) is\\nprovided during the visit\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D9944",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "50",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under TMJ Rider Frequency - 120 month replacement Eligible as\\nof 04/23/2023 No service history\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D9944",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "50",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under TMJ Rider Frequency - 120 month replacement Eligible as\\nof 04/23/2023 No service history\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7953",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "0",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Implant Rider Frequency - 120 month replacement This\\nbone graft code should not be billed if the tooth is still present.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7953",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "0",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Implant Rider Frequency - 120 month replacement This\\nbone graft code should not be billed if the tooth is still present.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D0240",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "5",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Preventive Frequency - 2 per calendar year Eligible as\\nof 04/23/2023 No service history D0706 is only payable when submitted\\nby an x-ray facility.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D0240",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "20",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Preventive Frequency - 2 per calendar year Eligible as\\nof 04/23/2023 No service history D0706 is only payable when submitted\\nby an x-ray facility.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7280",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7280",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7283",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7283",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D2954",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 120 month replacement Post and Core is\\nnot payable unless there is history of root canal therapy. Post and\\nCore is not payable if restorative procedure is not covered. These\\nservices are subject to Individual and/or Consultant review. See\\nSubmission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nIndirectly fabricated post and core is considered at the prefabricated\\npost and core rate.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D2954",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Frequency - 120 month replacement Post and Core is\\nnot payable unless there is history of root canal therapy. Post and\\nCore is not payable if restorative procedure is not covered. These\\nservices are subject to Individual and/or Consultant review. See\\nSubmission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nIndirectly fabricated post and core is considered at the prefabricated\\npost and core rate.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7960",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history These\\nservices are subject to Individual and/or Consultant review. See\\nSubmission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nPlease provide x-rays, photos, and clinical narrative for review.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7960",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history These\\nservices are subject to Individual and/or Consultant review. See\\nSubmission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nPlease provide x-rays, photos, and clinical narrative for review.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7962",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history These\\nservices are subject to Individual and/or Consultant review. See\\nSubmission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nPlease provide x-rays, photos, and clinical narrative for review.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7962",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history These\\nservices are subject to Individual and/or Consultant review. See\\nSubmission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nPlease provide x-rays, photos, and clinical narrative for review.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7310",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history These\\nservices are subject to Individual and/or Consultant review. See\\nSubmission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nRadiographs must verify need to substantially reshape alveolar bone in\\npreparation for a fixed or removable prosthetic\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7310",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history These\\nservices are subject to Individual and/or Consultant review. See\\nSubmission Guidelines here\\nsecure02.principal.com/publicvsupply/GetFile?fm=GP58750A&ty=PDF&EXT=.PDF\\nRadiographs must verify need to substantially reshape alveolar bone in\\npreparation for a fixed or removable prosthetic\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7286",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history We do\\nnot cover biopsies of the lip, cheek, tongue, or any area outside of\\nthe oral cavity. Please provide a path report, description and\\nlocation of the procedure performed and x-rays or photos.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7286",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history We do\\nnot cover biopsies of the lip, cheek, tongue, or any area outside of\\nthe oral cavity. Please provide a path report, description and\\nlocation of the procedure performed and x-rays or photos.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7285",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history We do\\nnot cover biopsies of the lip, cheek, tongue, or any area outside of\\nthe oral cavity. Please provide a path report, description and\\nlocation of the procedure performed and x-rays or photos.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7285",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history We do\\nnot cover biopsies of the lip, cheek, tongue, or any area outside of\\nthe oral cavity. Please provide a path report, description and\\nlocation of the procedure performed and x-rays or photos.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7510",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history A\\nseparate benefit is not considered if done on the same day as an\\nextraction.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D7510",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "60",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Major Eligible as of 04/23/2023 No service history A\\nseparate benefit is not considered if done on the same day as an\\nextraction.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D0460",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "10",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Basic Eligible as of 04/23/2023 No service history We\\nallow one D0460 per date of service.\\n"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "code": "D0460",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "percent": "40",\n' +
      // '        "authorizationRequired": "No",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Covered under Basic Eligible as of 04/23/2023 No service history We\\nallow one D0460 per date of service.\\n"\n' +
      // '      }\n' +
      // '    ],\n' +
      // '    "deductible": [\n' +
      // '      {\n' +
      // '        "serviceType": "Routine (Preventive) Dental",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Family",\n' +
      // '        "planPeriod": "Calendar Year",\n' +
      // '        "amount": "0.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "serviceType": "Routine (Preventive) Dental",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Family",\n' +
      // '        "planPeriod": "Remaining",\n' +
      // '        "amount": "0.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "serviceType": "Routine (Preventive) Dental",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Family",\n' +
      // '        "planPeriod": "Calendar Year",\n' +
      // '        "amount": "150.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "serviceType": "Routine (Preventive) Dental",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Family",\n' +
      // '        "planPeriod": "Remaining",\n' +
      // '        "amount": "150.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "serviceType": "Restorative",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Family",\n' +
      // '        "planPeriod": "Calendar Year",\n' +
      // '        "amount": "75.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "serviceType": "Restorative",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Family",\n' +
      // '        "planPeriod": "Remaining",\n' +
      // '        "amount": "75.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Basic and Major deductibles are combined"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "serviceType": "Restorative",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Family",\n' +
      // '        "planPeriod": "Calendar Year",\n' +
      // '        "amount": "75.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "serviceType": "Restorative",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Family",\n' +
      // '        "planPeriod": "Remaining",\n' +
      // '        "amount": "75.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Basic and Major deductibles are combined"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "serviceType": "Diagnostic Dental",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Family",\n' +
      // '        "planPeriod": "Calendar Year",\n' +
      // '        "amount": "75.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "serviceType": "Diagnostic Dental",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Family",\n' +
      // '        "planPeriod": "Remaining",\n' +
      // '        "amount": "75.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Basic and Major deductibles are combined"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "serviceType": "Diagnostic Dental",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Family",\n' +
      // '        "planPeriod": "Calendar Year",\n' +
      // '        "amount": "75.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "serviceType": "Diagnostic Dental",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Family",\n' +
      // '        "planPeriod": "Remaining",\n' +
      // '        "amount": "75.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Basic and Major deductibles are combined"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "serviceType": "Routine (Preventive) Dental",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "planPeriod": "Calendar Year",\n' +
      // '        "amount": "0.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "serviceType": "Routine (Preventive) Dental",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "planPeriod": "Remaining",\n' +
      // '        "amount": "0.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "serviceType": "Routine (Preventive) Dental",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "planPeriod": "Calendar Year",\n' +
      // '        "amount": "50.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "serviceType": "Routine (Preventive) Dental",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "planPeriod": "Remaining",\n' +
      // '        "amount": "50.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "serviceType": "Restorative",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "planPeriod": "Calendar Year",\n' +
      // '        "amount": "25.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "serviceType": "Restorative",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "planPeriod": "Remaining",\n' +
      // '        "amount": "25.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Basic and Major deductibles are combined"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "serviceType": "Restorative",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "planPeriod": "Calendar Year",\n' +
      // '        "amount": "25.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "serviceType": "Restorative",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "planPeriod": "Remaining",\n' +
      // '        "amount": "25.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Basic and Major deductibles are combined"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "serviceType": "Diagnostic Dental",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "planPeriod": "Calendar Year",\n' +
      // '        "amount": "25.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "serviceType": "Diagnostic Dental",\n' +
      // '        "network": "In-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "planPeriod": "Remaining",\n' +
      // '        "amount": "25.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Basic and Major deductibles are combined"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "serviceType": "Diagnostic Dental",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "planPeriod": "Calendar Year",\n' +
      // '        "amount": "25.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      // '      },\n' +
      // '      {\n' +
      // '        "serviceType": "Diagnostic Dental",\n' +
      // '        "network": "Out-Of-Network",\n' +
      // '        "coverageLevel": "Individual",\n' +
      // '        "planPeriod": "Remaining",\n' +
      // '        "amount": "25.00",\n' +
      // '        "insuranceType": "Preferred Provider Organization (PPO)",\n' +
      // '        "message": "Basic and Major deductibles are combined"\n' +
      // '      }\n' +
      '    ],\n' +
      '    "limitationAndMaximum": [\n' +
      '      {\n' +
      '        "serviceType": "Routine (Preventive) Dental",\n' +
      '        "network": "In-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "planPeriod": "Calendar Year",\n' +
      '        "amount": "2000.00",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      '      },\n' +
      '      {\n' +
      '        "serviceType": "Routine (Preventive) Dental",\n' +
      '        "network": "In-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "planPeriod": "Remaining",\n' +
      '        "amount": "2000.00",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      '      },\n' +
      '      {\n' +
      '        "serviceType": "Routine (Preventive) Dental",\n' +
      '        "network": "Out-Of-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "planPeriod": "Calendar Year",\n' +
      '        "amount": "2000.00",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      '      },\n' +
      '      {\n' +
      '        "serviceType": "Routine (Preventive) Dental",\n' +
      '        "network": "Out-Of-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "planPeriod": "Remaining",\n' +
      '        "amount": "2000.00",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      '      },\n' +
      '      {\n' +
      '        "serviceType": "Restorative",\n' +
      '        "network": "In-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "planPeriod": "Calendar Year",\n' +
      '        "amount": "2000.00",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      '      },\n' +
      '      {\n' +
      '        "serviceType": "Restorative",\n' +
      '        "network": "In-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "planPeriod": "Remaining",\n' +
      '        "amount": "2000.00",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      '      },\n' +
      '      {\n' +
      '        "serviceType": "Restorative",\n' +
      '        "network": "Out-Of-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "planPeriod": "Calendar Year",\n' +
      '        "amount": "2000.00",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      '      },\n' +
      '      {\n' +
      '        "serviceType": "Restorative",\n' +
      '        "network": "Out-Of-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "planPeriod": "Remaining",\n' +
      '        "amount": "2000.00",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      '      },\n' +
      '      {\n' +
      '        "serviceType": "Diagnostic Dental",\n' +
      '        "network": "In-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "planPeriod": "Calendar Year",\n' +
      '        "amount": "2000.00",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      '      },\n' +
      '      {\n' +
      '        "serviceType": "Diagnostic Dental",\n' +
      '        "network": "In-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "planPeriod": "Remaining",\n' +
      '        "amount": "2000.00",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      '      },\n' +
      '      {\n' +
      '        "serviceType": "Diagnostic Dental",\n' +
      '        "network": "Out-Of-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "planPeriod": "Calendar Year",\n' +
      '        "amount": "2000.00",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      '      },\n' +
      '      {\n' +
      '        "serviceType": "Diagnostic Dental",\n' +
      '        "network": "Out-Of-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "planPeriod": "Remaining",\n' +
      '        "amount": "2000.00",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      '      }\n' +
      '    ],\n' +
      '    "notCovered": [\n' +
      '      {\n' +
      '        "serviceType": "Orthodontics",\n' +
      '        "network": "In-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      '      },\n' +
      '      {\n' +
      '        "serviceType": "Orthodontics",\n' +
      '        "network": "Out-Of-Network",\n' +
      '        "coverageLevel": "Individual",\n' +
      '        "insuranceType": "Preferred Provider Organization (PPO)"\n' +
      '      }\n' +
      '    ]\n' +
      '  }\n' +
      '}';

    this.patientEligibilityResponse = JSON.parse(test);
    this.jsonResp = this.patientEligibilityResponse;
    // const blah = 'blah';

  }

  closeWindow() {
    this.dialogRef.close();
  }
}
